module.exports = __webpack_public_path__ + "static/media/weather.5ec812e1.jpg";